var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import MaterialElement from "../components/articleattributes/materialelement.vue";
let MaterialForm = class MaterialForm extends Vue {
    constructor() {
        super(...arguments);
        this.material = {
            material: {
                name: "",
                identifier: "",
                description: "",
            },
            cuttingGasId: "",
            invalid: true,
        };
    }
    valueChanged() { return this.material; }
    onChange(m) {
        this.material = m;
        this.valueChanged();
    }
    created() {
        this.material = this.defaultMaterial;
    }
};
__decorate([
    Prop({ required: true })
], MaterialForm.prototype, "defaultMaterial", void 0);
__decorate([
    Prop({ required: true })
], MaterialForm.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], MaterialForm.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], MaterialForm.prototype, "thicknesses", void 0);
__decorate([
    Inject()
], MaterialForm.prototype, "i18n", void 0);
__decorate([
    Emit()
], MaterialForm.prototype, "valueChanged", null);
MaterialForm = __decorate([
    Component({
        components: {
            MaterialElement,
        },
        name: "MaterialForm",
    })
], MaterialForm);
export default MaterialForm;
